export const localization = {
  pt: {
    at: 'às',
    by: 'Por',
    createPipelineButton: 'Criar pipeline',
    deletePipelineAlert: {
      body: 'Ao excluir esta Pipeline, todos os gatilhos relacionados serão removidos, podendo impactar funcionalidades que dependem dela.<br/><br/>Deseja excluir mesmo assim?',
      buttons: {
        cancel: 'Cancelar',
        confirm: 'Excluir',
      },
      title: 'Excluir pipeline',
    },
    emptyState: {
      subtitle: 'Para começar, crie um pipeline para adicionar conteúdos',
      title: 'Ainda não há pipelines',
    },
    errorDeletePipelineToast: {
      message: 'Não foi possível excluir o pipeline. Tente novamente.',
      title: 'Falha ao excluir pipeline',
    },
    headerContent: 'Pipeline',
    searchPlaceholder: 'Pesquisar',
    subtitle: 'Gerencie os fluxos de conversa para manter os agentes atualizados com jornadas automatizadas.',
    successDeletePipelineToast: {
      message: 'O pipeline foi excluído da base de conhecimento.',
      title: 'Pipeline excluído',
    },
    tableHeaders: {
      pipeline: 'Pipeline',
      id: 'ID',
      tasks: 'Tarefas',
      status: 'Status',
    },
    title: 'Gerenciar Pipeline',
    pipelineActions: {
      open: 'Abrir',
      team: 'Equipe',
      logs: 'Logs',
      delete: 'Excluir',
    },
    pipelineStatus: {
      published: 'Publicada',
      unpublished: 'Despublicada',
    },
  },
  en: {
    at: 'at',
    by: 'By',
    createPipelineButton: 'Create pipeline',
    deletePipelineAlert: {
      body: 'By deleting this Pipeline, all related triggers will be removed, potentially impacting functionalities that depend on it.<br/><br/>Do you still want to delete it?',
      buttons: {
        cancel: 'Cancel',
        confirm: 'Delete',
      },
      title: 'Delete pipeline',
    },
    emptyState: {
      subtitle: 'To get started, create a pipeline to add content',
      title: 'No pipelines yet',
    },
    errorDeletePipelineToast: {
      message: 'Could not delete the pipeline. Please try again.',
      title: 'Failed to delete pipeline',
    },
    headerContent: 'Pipeline',
    searchPlaceholder: 'Search',
    subtitle: 'Manage conversation flows to keep agents updated with automated journeys.',
    successDeletePipelineToast: {
      message: 'The pipeline has been deleted from the knowledge base.',
      title: 'Pipeline deleted',
    },
    tableHeaders: {
      pipeline: 'Pipeline',
      id: 'ID',
      tasks: 'Tasks',
      status: 'Status',
    },
    title: 'Manage Pipeline',
    pipelineActions: {
      open: 'Open',
      logs: 'Logs',
      team: 'Team',
      delete: 'Delete',
    },
    pipelineStatus: {
      published: 'Published',
      unpublished: 'Unpublished',
    },
  },
  es: {
    at: 'a las',
    by: 'Por',
    createPipelineButton: 'Crear pipeline',
    deletePipelineAlert: {
      body: 'Al eliminar esta Pipeline, todos los disparadores relacionados serán eliminados, pudiendo afectar funcionalidades que dependen de ella.<br/><br/>¿Desea eliminarlo de todos modos?',
      buttons: {
        cancel: 'Cancelar',
        confirm: 'Eliminar',
      },
      title: 'Eliminar pipeline',
    },
    emptyState: {
      subtitle: 'Para comenzar, cree un pipeline para agregar contenido',
      title: 'Aún no hay pipelines',
    },
    errorDeletePipelineToast: {
      message: 'No se pudo eliminar el pipeline. Inténtalo de nuevo.',
      title: 'Error al eliminar el pipeline',
    },
    headerContent: 'Pipeline',
    searchPlaceholder: 'Buscar',
    subtitle:
      'Gestione los flujos de conversación para mantener a los agentes actualizados con jornadas automatizadas.',
    successDeletePipelineToast: {
      message: 'El pipeline ha sido eliminado de la base de conocimiento.',
      title: 'Pipeline eliminado',
    },
    tableHeaders: {
      pipeline: 'Pipeline',
      id: 'ID',
      tasks: 'Tareas',
      status: 'Estado',
    },
    title: 'Gestionar Pipeline',
    pipelineActions: {
      open: 'Abrir',
      team: 'Equipo',
      logs: 'Logs',
      delete: 'Eliminar',
    },
    pipelineStatus: {
      published: 'Publicada',
      unpublished: 'Despublicada',
    },
  },
};
